<script lang="ts" context="module">
	export function namesub(a:string, b?:string) {
		a = slugify(a);
		if (!b) return a;
		return slugify(a) + '-' + slugify(b);
	}
</script>

<script lang="ts">
	import type { RestaurantDynamic, RestaurantSemiStatic, TileRestaurant } from "$lib/def/landing";
	import type { RestaurantDeal } from "$lib/serv/food-landing";

  import { watchCartHeader } from '$lib/serv/food-cart';
  import { LOCATION_PROPS } from "$lib/serv/locations";
  import { getRestaurantState } from "$lib/serv/restaurant";
  import { formatFoodReadyTime, merchantNameSuburbSlug, slugify } from '$lib/util/format';
  import { queryFrom } from "$lib/util/url";
  import { EMPTY } from 'rxjs';
  import { fade } from 'svelte/transition';
	import { Vertical } from "$lib/def/verticals";

	import LazyImage from '$lib/ui/shared/LazyBackgroundImage.svelte';
	import StatusPills from "$lib/ui/shared/StatusPills.svelte";

	export let searchParams: Record<string, string>;
	export let tile: TileRestaurant;
	export let semistatic: RestaurantSemiStatic | undefined;
	export let dynamic: RestaurantDynamic | undefined;
	export let deals: RestaurantDeal[] | undefined;
	// export let animationDelay = 0;

	$: foodReadyTime = (dynamic?.estimated_delivery_time_for_distance ?? 0) + (dynamic?.prep_time ?? 0);
	// $: cart$ = (semistatic || dynamic)?.id ? watchCartHeader((semistatic || dynamic)?.id!, false) : EMPTY;
	$: rest = {...semistatic, ...dynamic, address: {
		...semistatic?.address,
		...dynamic?.address,
	}} as RestaurantSemiStatic & RestaurantDynamic;
	$: state = getRestaurantState(rest);
</script>

<a href={queryFrom(searchParams).keep(...LOCATION_PROPS).set('vertical', dynamic?.vertical || Vertical.Restaurant).toUrl(`/delivery/${dynamic?.vertical || Vertical.Restaurant}/${merchantNameSuburbSlug(rest.name,rest.address?.suburb)}/${tile.payload.id}`)} class="item" in:fade|global data-testid={`tile_${semistatic?.id}`}>
	
	<LazyImage image={[semistatic?.images?.restaurant_header, 500]} alt={semistatic?.name || tile.type}>
		
		{#if deals}
			{#if deals.length > 1}
				<StatusPills pills={[ {pos: 'TL', color: 'red', text: 'On Special'} ]} />
			{:else}
				{#each deals as deal}
					<StatusPills pills={[ {pos: 'TL', color: 'red', text: deal.label} ]} />
				{/each}
			{/if}
		{/if}

		{#if state.offline}
			<StatusPills pills={[ {pos: 'C', color: 'white', text: 'Offline', subText: state.text} ]} darkended={true} />
		{:else if state.collect_only}
			<StatusPills pills={[ {pos: 'C', color: 'white', text: state.text, icon: 'icon-collect-16' } ]} darkended={true} />
		{/if}

		{#if rest.indicators}
			{#each rest.indicators as indicator}
				<StatusPills pills={[ {pos: 'BL', color: 'grey', text: indicator.title} ]} />
			{/each}
		{/if}

		{#if rest.classifications}
			{@const classifications = rest.classifications.map(cls => cls.name).join(' | ')}
			<StatusPills pills={[ {pos: 'BR', color: 'grey', text: classifications} ]} />
		{/if}

	</LazyImage>

	<div class="text" aria-label={semistatic?.name}>
		<h5 class="name label-standard bold ellipses">{semistatic?.name}</h5>
		<div>
			<p class="info label-standard book">
				{#if dynamic?.sponsored}Sponsored &bull;{/if}
				{#if dynamic?.statistics}
					{@const stats = dynamic?.statistics}
						{#if stats.avg_food_quality_rating}
						<span>{dynamic.statistics?.avg_food_quality_rating}</span>
						<span class="icon-star-20"></span>
						{#if stats.number_of_ratings_str}
						<span>{stats.number_of_ratings_str}</span>
						<span>&#183;</span>{/if}
						<span>{formatFoodReadyTime(foodReadyTime)}</span>
					{:else if !dynamic?.statistics?.avg_food_quality_rating}
						<span>{formatFoodReadyTime(foodReadyTime)}</span>
					{/if}
					<!-- TODO: Dan - add this when implementing real multi-cart -->
					<!-- {#if $cart$}
						{@const cart = $cart$}
						{#if cart.itemCount}
						<span class="cartItems">{cart.itemCount}</span>
						{/if}
					{/if} -->
				{/if}
			</p>
		</div>
	</div>
</a>
